'use client';
import MuxPlayer from '@mux/mux-player-react';
import styled from 'styled-components';

export const StyledMuxPlayer = styled(MuxPlayer)`
  width: 100%;
  aspect-ratio: ${props => props.aspectRatio};
  --media-object-fit: cover;
  --bottom-controls: ${props => (props.showScrollControls ? 'flex' : 'none')};
  --play-button: ${props => (!props.autoPlay ? 'block' : 'none')};
  &::part(playback-rate) {
    display: none;
  }
  &::part(range) {
    --media-time-range-buffered-color: transparent;
    --media-range-bar-color: ${props => props.theme.colors.background.base};
  }
  &::part(center play button) {
    background-color: ${props => props.theme.colors.hero.lilac};
    padding: 22px 16px;
    min-width: 58px;
    border-radius: 58px;
    border: none;
    stroke: none;
    stroke-width: 0;
  }
  &::part(seek-forward),
  &::part(seek-backward) {
    display: none;
  }
`;
